import React from 'react';

import { Circle, Rectangle, SkeletonContainer } from '../../../LoadingSkeletons';

import { FooterStyles, RectangleShapeStyles } from './Footer.styles';
import type { FacebookStoryComponentsProps } from './types';

export const Footer: React.FC<FacebookStoryComponentsProps> = (props) => {
	const { size, loading, retryState } = props;

	if (size === 'xsmall' && loading) {
		return null;
	}

	// Disable animation when in failed retry state (static background for better contrast)
	const shouldAnimate = loading && retryState !== 'failed';

	return (
		<SkeletonContainer
			className={FooterStyles({ size })}
			shapeColorClassName="bg-icon-weak"
			shapeSize={size}
			loading={shouldAnimate}
		>
			<Rectangle className={RectangleShapeStyles({ size })} rounded />
			<Circle />
			<Circle />
		</SkeletonContainer>
	);
};
